import React from "react";
import "./Home.css";

const Terms = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
        {/* Animated Background Blurs */}
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#4299f5] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-1/2 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
        
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-4 animate-fade-in-up" style={{fontFamily: 'Montserrat, sans-serif'}}>
            Terms of Service
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 animate-fade-in-up animation-delay-200">
            Please read these terms carefully before using our services.
          </p>
          <p className="text-sm text-gray-400 mt-4 animate-fade-in-up animation-delay-400">Last updated: November 19, 2025</p>
        </div>
      </section>

      {/* Content Section */}
      <div className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-8 sm:p-12 border-2 border-transparent hover:border-[#4299f5] transition-all duration-300">

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                1. Acceptance of Terms
              </h2>
            <p>
              By accessing and using Trivana Hospitality's website and services ("Service"), you accept and agree 
              to be bound by the terms and provision of this agreement. If you do not agree to these Terms of 
              Service, please do not use our Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                2. Description of Service
              </h2>
            <p>
              Trivana Hospitality provides hospitality management services and related information through our 
              website. We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) 
              at any time with or without notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                3. User Accounts
              </h2>
              <p className="mb-3">When you create an account with us, you agree to:</p>
              <ul className="list-none space-y-2 ml-0">
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Provide accurate, current, and complete information during registration</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Maintain and promptly update your account information</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Maintain the security of your password and accept all risks of unauthorized access</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Immediately notify us of any unauthorized use of your account</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Be responsible for all activities that occur under your account</span>
                </li>
              </ul>
              <p className="mt-3">
                We reserve the right to suspend or terminate your account if any information provided proves to be 
                inaccurate, false, or misleading.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                4. Google Sign-In
              </h2>
            <p>
              If you choose to sign in using Google OAuth, you agree that your use of Google's authentication 
              service is also subject to Google's Terms of Service and Privacy Policy. We are not responsible 
              for any issues arising from your use of Google's services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                5. Acceptable Use
              </h2>
              <p className="mb-3">You agree NOT to use the Service to:</p>
              <ul className="list-none space-y-2 ml-0">
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Violate any applicable laws or regulations</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Infringe upon intellectual property rights of others</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Transmit any harmful code, viruses, or malware</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Engage in any fraudulent, abusive, or harassing behavior</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Attempt to gain unauthorized access to our systems or networks</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Interfere with or disrupt the Service or servers</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Use automated systems (bots, scrapers) without permission</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Impersonate any person or entity</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                6. Intellectual Property
              </h2>
            <p>
              The Service and its original content, features, and functionality are owned by Trivana Hospitality 
              and are protected by international copyright, trademark, patent, trade secret, and other intellectual 
              property laws. You may not copy, modify, distribute, sell, or lease any part of our Service without 
              our explicit written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                7. Privacy and Data Protection
              </h2>
            <p>
              Your use of the Service is also governed by our Privacy Policy. Please review our Privacy Policy to 
              understand how we collect, use, and protect your personal information.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                8. Disclaimer of Warranties
              </h2>
            <p>
              The Service is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, whether express 
              or implied. We do not warrant that the Service will be uninterrupted, timely, secure, or error-free. 
              We do not warrant that the results obtained from the use of the Service will be accurate or reliable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                9. Limitation of Liability
              </h2>
              <p>
                To the maximum extent permitted by law, Trivana Hospitality shall not be liable for any indirect, 
                incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether 
                incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses 
                resulting from:
              </p>
              <ul className="list-none space-y-2 ml-0 mt-3">
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Your use or inability to use the Service</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Unauthorized access to or alteration of your data</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Any conduct or content of third parties on the Service</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-[#4299f5] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>Any content obtained from the Service</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                10. Indemnification
              </h2>
            <p>
              You agree to indemnify, defend, and hold harmless Trivana Hospitality, its officers, directors, 
              employees, agents, and affiliates from any claims, damages, losses, liabilities, and expenses 
              (including legal fees) arising out of your use of the Service, your violation of these Terms, 
              or your violation of any rights of another.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                11. Termination
              </h2>
            <p>
              We may terminate or suspend your account and access to the Service immediately, without prior notice 
              or liability, for any reason, including without limitation if you breach these Terms. Upon termination, 
              your right to use the Service will immediately cease.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                12. Changes to Terms
              </h2>
            <p>
              We reserve the right to modify or replace these Terms at any time at our sole discretion. If a 
              revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. 
              What constitutes a material change will be determined at our sole discretion. By continuing to access 
              or use our Service after revisions become effective, you agree to be bound by the revised terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                13. Governing Law
              </h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of India, without regard to 
              its conflict of law provisions. Our failure to enforce any right or provision of these Terms will 
              not be considered a waiver of those rights.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                14. Severability
              </h2>
            <p>
              If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining 
              provisions of these Terms will remain in effect.
              </p>
            </section>

            <section>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                <span className="inline-block w-2 h-8 bg-[#4299f5] mr-3 rounded"></span>
                15. Contact Us
              </h2>
              <p>
                If you have any questions about these Terms of Service, please contact us:
              </p>
              <div className="mt-4 p-6 bg-gray-50 rounded-lg border-l-4 border-[#4299f5]">
                <ul className="list-none space-y-2">
                  <li className="flex items-center">
                    <span className="text-[#4299f5] font-bold mr-2">✉</span>
                    <span><strong className="text-gray-900">Email:</strong> trivanahospitality@gmail.com</span>
                  </li>
                  <li className="flex items-center">
                    <span className="text-[#4299f5] font-bold mr-2">🌐</span>
                    <span><strong className="text-gray-900">Website:</strong> trivanahospitality.com</span>
                  </li>
                </ul>
              </div>
            </section>

            <div className="mt-6 p-6 bg-gradient-to-r from-[#4299f5]/10 to-purple-500/10 rounded-xl border-2 border-[#4299f5]/30 shadow-lg">
              <p className="text-sm text-gray-700 leading-relaxed">
                <strong className="text-gray-900 text-base">Acknowledgment:</strong> By using the Service, you acknowledge that you have read these 
                Terms of Service and agree to be bound by them.
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t-2 border-gray-200">
            <a 
              href="/" 
              className="inline-flex items-center text-[#4299f5] hover:text-[#3a8fe5] font-semibold text-lg transition-colors duration-200"
              style={{fontFamily: 'Montserrat, sans-serif'}}
            >
              <span className="mr-2">←</span> Back to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
